import { DEFAULT_REDEEM } from './default';
import { VIEW_REWARD } from './viewReward';

export const REDEEM = {
  VIEW_REWARD,
  DEFAULT_REDEEM
};
